import {
  Component,
  Input,
  OnInit,
  NgModule,
  ContentChild,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UIGridComponent } from './yzt-grid.component';
export class GridIconComponent {

   iconTemplate: TemplateRef<any>;
   outField = '';
   outProp = '';
   uiGrid: UIGridComponent;
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {

  }
/**
 * @param {?} simple
 * @return {?}
 */
ngOnChanges(simple) {
    if(this.uiGrid && simple['outField']) {
      this.uiGrid.getIconInstance(this);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'grid-icon',
  template: `
    <ng-container></ng-container>
  `,
  styles: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'iconTemplate': [{ type: ContentChild, args: ['iconTemplate', ] },],
'outField': [{ type: Input },],
'outProp': [{ type: Input },],
'uiGrid': [{ type: Input, args: ['ui_grid', ] },],
};
}

function GridIconComponent_tsickle_Closure_declarations() {
/** @type {?} */
GridIconComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GridIconComponent.ctorParameters;
/** @type {?} */
GridIconComponent.propDecorators;
/** @type {?} */
GridIconComponent.prototype.iconTemplate;
/** @type {?} */
GridIconComponent.prototype.outField;
/** @type {?} */
GridIconComponent.prototype.outProp;
/** @type {?} */
GridIconComponent.prototype.uiGrid;
}

export class GridIconModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    GridIconComponent
  ],
  exports: [GridIconComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function GridIconModule_tsickle_Closure_declarations() {
/** @type {?} */
GridIconModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GridIconModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
